import axios from 'axios'
import { isObject, merge, uniq } from 'lodash'
import getCookie from '@/utils/getCookie'
import { renameKeysToSnakeCase, renameKeysToCamelCase } from '@/utils/renameKeys'

const api = axios.create({
  timeout: 50000,
  headers: {
    'X-CSRF-Token': getCookie('csrf_cookie'),
  },
})
api.interceptors.response.use(undefined, err => err.response)

if (process.env.NODE_ENV !== 'production') {
  require('./mock').default(api)
}

/**
 * API に POST します。
 *
 * @param {string} path APIのパス
 * @param {object} params リクエストパラメータ
 * @param {object} config axios config
 */
export default async function(path, params = {}, config = {}) {
  if (params instanceof FormData) {
    // ローカルの場合はFormDataの中身をparamsに入れる
    if (STAGE === STAGE_LOCAL) {
      const formatParams = {}
      Array(...params.entries()).forEach(item => {
        formatParams[item[0]] = item[1]
      })
      params = formatParams
    }
    config = merge({ headers: { 'Content-Type': 'multipart/form-data' } }, config)
  } else {
    params = renameKeysToSnakeCase(params)
  }
  if (process.env.NODE_ENV !== 'test') console.log('%cPOST %c%s', 'color: green;', '', path, params)
  const res = await api.post(path, params, config)
  if (process.env.NODE_ENV !== 'test') {
    if (res.status === 200) {
      console.log('%c%d %c%s', 'color: blue;', res.status, '', path, res.data)
    } else {
      console.error('%d %s', res.status, path, res.data)
    }
  }
  return handleResponse(res)
}

function handleResponse({ status, code, data: resData }) {
  if (!status && code !== 'ECONNABORTED') {
    return { status: 0, data: null, message: '' }
  }

  const data = isObject(resData) ? renameKeysToCamelCase(resData.data || resData) : null
  if (status === 200 && resData && resData.status === 1) return { status, data }

  const { message, messages, error = {}, errors = [] } = data || {}
  return {
    status,
    data,
    message:
      message ||
      messages ||
      error.message ||
      (errors.length && uniq(errors.map(e => e.message))) ||
      'しばらくしてから再度ご利用ください',
  }
}
